module.exports = __webpack_public_path__ + "img/img-ebcd63a0.2418a928.png";